import React from "react";
import { showMessages } from "../../../components/AlertMessages/AlertMessages";
import { P206BGetDataList, P206BUpdateData } from "../../../service/200/P206BService";
import { P206CGetDataList, P206CUpdateData } from "../../../service/200/P206CService";
import { P206DGetDataList, P206DUpdateData } from "../../../service/200/P206DService";
import { P206EGetDataList, P206EUpdateData } from "../../../service/200/P206EService";
import { P206FGetDataList, P206FUpdateData } from "../../../service/200/P206FService";
import { P206GetDataInfo, P206GetPicDataList, P206UpdateClose, P206UpdateData, P206UpdateInspectorData, PSupervisorInspectCaseReport } from "../../../service/200/P206Service";
import {renderExportFile, renderExportFileWindow} from "../../../components/ExportFile/ExportFileTools";
//Main & Panel_A
export const onP206GetDataInfo = (setLoading, setFormObject, setDataTableA, searchData, setErrData) => {
    setLoading(true);
    P206GetDataInfo(searchData).then(
        (res) => {
            if (res !== undefined) {
                if (res[0]) {
                    setFormObject(res[0]);
                    setDataTableA(res[0]);
                }
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
            setLoading(false);
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

export const onP206UpdateData = async (data, setLoading, setShowDialog, setTextShow, setErrData) => {
    setLoading(true);
    await P206UpdateData(data).then(
        (res) => {
            setLoading(false);

            if (res.status === 200) {
                if (res.data[0]) {
                    // let rtn = res.data[0].statusCode === 'C'?'บันทึกข้อมูลสำเร็จ':res.data[0].statusCode === 'E'?'มีข้อผิดพลาด':res.data[0].statusText;
                    let rtn = res.data[0].statusText;
                    setTextShow(`${rtn}`);
                    setShowDialog(true);
                }
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

// Panel_B
export const onP206BGetDataList = (setLoading, searchData, setDataTableB, setErrData) => {
    setLoading(true);

    P206BGetDataList(searchData).then(
        (res) => {
            setLoading(false);
            // console.log(res);
            if (res !== undefined) {
                let temp = [];
                let index = 1;
                res.forEach((element) => {
                    temp.push({
                        ...element,
                        index: index,
                    });
                    index++;
                });
                setDataTableB(temp);
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
            console.log("🚀 ~ file: P206_CallService.js ~ line 82 ~ onP206BGetDataList ~ err", err);
        }
    );
};

export const onP206BUpdateData = async (data, setLoading, setShowDialog, setTextShow, setErrData) => {
    setLoading(true);
    await P206BUpdateData(data).then(
        (res) => {
            setLoading(false);

            if (res.status === 200) {
                if (res.data[0]) {
                    // let rtn = res.data[0].statusCode === "C" ? "บันทึกข้อมูลสำเร็จ" : res.data[0].statusCode === "E" ? "มีข้อผิดพลาด" : res.data[0].statusText;
                    // setTextShow(`${rtn}`);
                    // setTextShow(`${res.data[0].statusText}`);
                    // setShowDialog(true);
                }
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

//Panel_C
export const onP206CGetDataList = (setLoading, searchData, setDataTableC, setErrData) => {
    setLoading(true);
    P206CGetDataList(searchData).then(
        (res) => {
            setLoading(false);
            // console.log(res);
            if (res !== undefined) {
                setDataTableC(res[0]);
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

export const onP206CUpdateData = async (data, setLoading, setShowDialog, setTextShow, setErrData) => {
    setLoading(true);
    await P206CUpdateData(data).then(
        (res) => {
            setLoading(false);

            if (res.status === 200) {
                if (res.data[0]) {
                    // let rtn = res.data[0].statusCode === "C" ? "บันทึกข้อมูลสำเร็จ" : res.data[0].statusCode === "E" ? "มีข้อผิดพลาด" : res.data[0].statusText;
                    let rtn = res.data[0].statusText;
                    // console.log(rtn);
                    // setTextShow(`${rtn}`);
                    // setShowDialog(true);
                }
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            console.log("FUCKKKKKKK");
            setLoading(false);
            setErrData(err);
        }
    );
};

//Panel_D
export const onP206DGetDataList = (setLoading, searchData, setDataTableC, setErrData) => {
    setLoading(true);
    P206DGetDataList(searchData).then(
        (res) => {
            setLoading(false);
            // console.log(res);
            if (res !== undefined) {
                setDataTableC(res[0]);
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

export const onP206DUpdateData = async (data, setLoading, setShowDialog, setTextShow, setErrData) => {
    setLoading(true);
    await P206DUpdateData(data).then(
        (res) => {
            setLoading(false);

            if (res.status === 200) {
                if (res.data[0]) {
                    let rtn = res.data[0].statusCode === "C" ? "บันทึกข้อมูลสำเร็จ" : res.data[0].statusCode === "E" ? "มีข้อผิดพลาด" : res.data[0].statusText;
                    // let rtn = res.data[0].statusText;

                    // setTextShow(`${rtn}`);
                    // setShowDialog(true);
                }
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

//Panel_E
export const onP206EGetDataList = (setLoading, searchData, setDataTableC, setErrData) => {
    setLoading(true);
    P206EGetDataList(searchData).then(
        (res) => {
            setLoading(false);
            // console.log(res);
            if (res !== undefined) {
                setDataTableC(res[0]);
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

export const onP206EUpdateData = async (data, setLoading, setShowDialog, setTextShow, setErrData) => {
    setLoading(true);
    await P206EUpdateData(data).then(
        (res) => {
            setLoading(false);

            if (res.status === 200) {
                if (res.data[0]) {
                    let rtn = res.data[0].statusCode === "C" ? "บันทึกข้อมูลสำเร็จ" : res.data[0].statusCode === "E" ? "มีข้อผิดพลาด" : res.data[0].statusText;
                    // setTextShow(`${rtn}`);
                    // setShowDialog(true);
                }
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

//Panel_F
export const onP206FGetDataList = (setLoading, searchData, setDataTableC, setErrData) => {
    setLoading(true);
    P206FGetDataList(searchData).then(
        (res) => {
            setLoading(false);
            // console.log(res);
            if (res !== undefined) {
                setDataTableC(res[0]);
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

export const onP206FUpdateData = async (data, setLoading, setShowDialog, setTextShow, setErrData) => {
    setLoading(true);
    await P206FUpdateData(data).then(
        (res) => {
            setLoading(false);

            if (res.status === 200) {
                if (res.data[0]) {
                    let rtn = res.data[0].statusCode === "C" ? "บันทึกข้อมูลสำเร็จ" : res.data[0].statusCode === "E" ? "มีข้อผิดพลาด" : res.data[0].statusText;

                    // let rtn = res.data[0].statusText;
                    // setTextShow(`${rtn}`);
                    // setShowDialog(true);
                }
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

//Picture
export const onP206GetPicDataList = (setLoading, setDataPic, searchPicData, setErrData) => {
    setLoading(true);

    P206GetPicDataList(searchPicData).then(
        (res) => {
            setLoading(false);
            // console.log('onP206GetPicDataList - res ',res)
            if (res !== undefined) {
                let temp = [];
                let index = 1;
                res.forEach((element) => {
                    temp.push({
                        ...element,
                        index: index,
                    });
                    index++;
                });
                // temp.push(...temp)
                setDataPic(temp);
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

export const onP206UpdateClose = (data, setLoading, setShowDialog, setTextShow, setErrData) => {
    setLoading(true);
    P206UpdateClose(data).then(
        (res) => {
            setLoading(false);
            if (res.status === 200) {
                if (res.data[0].statusText === "") {
                    if (res.data[0].statusCode === "C") {
                        setTextShow(`บันทึกข้อมูลสำเร็จ `);
                    } else if (res.data[0].statusCode === "E") {
                        setTextShow(`มีข้อผิดพลาด`);
                    }
                } else {
                    setTextShow(`${res.data[0].statusText}`);
                }
                setShowDialog(true);
            } else {
                setErrData({
                    text: `ไม่พบข้อมูล `,
                });
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};

export const onP206UpdateInspectorData = async (data, setLoading, setShowDialog, setTextShow, setErrData) => {
    setLoading(true);
    await P206UpdateInspectorData(data).then(
        (res) => {
            setLoading(false);
            if (res.status === 200) {
                if (res.data[0].statusText === "") {
                    if (res.data[0].statusCode === "C") {
                        setTextShow(`บันทึกข้อมูลสำเร็จ `);
                    } else if (res.data[0].statusCode === "E") {
                        setTextShow(`มีข้อผิดพลาด`);
                    }
                } else {
                    setTextShow(`${res.data[0].statusText}`);
                }
                setShowDialog(true);
            } else {
                showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
            }
        },
        function (err) {
            setLoading(false);
            setErrData(err);
        }
    );
};



export const onExportReport = async (exportType, searchData, setErrData, setLoading) => {
    console.log("exportType : ",exportType)
    setLoading(true);
   
    let res = await PSupervisorInspectCaseReport({...searchData, exportype: exportType}, exportType);
    console.log("res : ",res)
    setLoading(false);
    if (res.data !== undefined) {
        //   await renderExportFile(res.data, exportType, menuCode, setDialogFile);
        await renderExportFileWindow(res.data, exportType, "206");
    } else {
        setErrData({type: "error", text: "ไม่สามารถ Export File ได้!!"});
    }
};
